const BACKEND_URL = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BACKEND_URL_PRODUCTION
    : process.env.REACT_APP_ENVIRONMENT === 'staging' ? process.env.REACT_APP_BACKEND_URL_STAGING
        : process.env.REACT_APP_BACKEND_URL_DEVELOPMENT


export {
    BACKEND_URL,
}